// eslint-disable-next-line no-shadow
export enum TransactionStatus {
    Authorized = 'authorized',
    Voided = 'voided',
    Captured = 'captured'
}
